import { Navigate, useParams } from 'react-router-dom';
import queryString from 'query-string';
import { removeAuthCredentials } from '@front-activerse/common-components';

const BuyAddPage = ({ pathBuySignup }) => {
  const { productId } = useParams();

  const queryStringObject = queryString.parse(global.location.search);
  const fromLanging = queryStringObject.from;
  const promoCode = queryStringObject.pc;
  const productPrice = queryStringObject.productPrice;
  const source = queryStringObject.source;

  if (productId) {
    removeAuthCredentials(); // logout user
    global.localStorage.setItem('buyProductId', productId);
    global.localStorage.setItem('buyProductPrice', productPrice);
    global.localStorage.setItem('buyFromLandinng', fromLanging);

    if (promoCode) {
      global.localStorage.setItem('buyPromoCode', promoCode);
    }

    if (source) {
      global.localStorage.setItem('buySource', source);
    }
    return <Navigate to={`${pathBuySignup}/${global.location.search}`} />;
  }

  window.location = import.meta.env.VITE_LANDING_PAGE_URL;
  return null;
};

export default BuyAddPage;
